exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spaces{\r\n  margin: 0px;\r\n  padding: 0px;\r\n  line-height: 1em;\r\n}\r\np{\r\n  padding: 0px;\r\n  margin: .4em;\r\n}\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/participants/participant/participant.component.css
// module id = ../../../../../src/app/participants/participant/participant.component.css
// module chunks = main